"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FindFavoritesContextMenu_1 = require("./components/FindFavoritesContextMenu");
exports.FindFavoritesContextMenu = FindFavoritesContextMenu_1.default;
//# sourceMappingURL=lazyIndex.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/owa-mail-find-favorites/lib/lazyIndex.js
// module id = 2590
// module chunks = 68